// Kontejner průvodce okny — mountuje se v desktop shellu. Řeší:
//  · automatické otevření komukoliv, kdo průvodce ještě neviděl (localStorage „seen" flag),
//  · vykreslení modálního průvodce (řízeno sdíleným store, spouští i položka menu „Nástroje"),
//  · vyskakovací info okno po předčasném přeskočení (kde se průvodce znovu otevře).

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui/button';
import { Dialog } from '@/shared/ui/dialog';

import { useWindowOnboardingStore } from './useWindowOnboardingStore';
import { hasSeenWindowOnboarding, markWindowOnboardingSeen } from './windowOnboardingStorage';
import { WindowOnboardingWizard, type WindowOnboardingCloseReason } from './WindowOnboardingWizard';

export function WindowOnboarding() {
  const { t } = useTranslation('windowOnboarding');
  const open = useWindowOnboardingStore((s) => s.open);
  const openWizard = useWindowOnboardingStore((s) => s.openWizard);
  const closeWizard = useWindowOnboardingStore((s) => s.closeWizard);
  const [skipInfoOpen, setSkipInfoOpen] = useState(false);

  // Automaticky otevři průvodce tomu, kdo ho ještě neviděl (jen jednou při startu shellu).
  useEffect(() => {
    if (!hasSeenWindowOnboarding()) openWizard();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- záměrně jen na mount
  }, []);

  const handleClose = (_reason: WindowOnboardingCloseReason) => {
    markWindowOnboardingSeen();
    closeWizard();
    // Po každém zavření (dokončení i předčasné ukončení) ukaž, kde se průvodce znovu otevře.
    setSkipInfoOpen(true);
  };

  return (
    <>
      <WindowOnboardingWizard open={open} onClose={handleClose} />

      {skipInfoOpen && (
        <Dialog
          open
          onClose={() => setSkipInfoOpen(false)}
          title={t('skipPopup.title')}
          description={t('skipPopup.message')}
          icon="info"
          tone="primary"
          width="sm"
          footer={
            <Button variant="primary" size="md" onClick={() => setSkipInfoOpen(false)}>
              {t('skipPopup.ok')}
            </Button>
          }
        />
      )}
    </>
  );
}
